import React from "react";

import { Modal } from "../../../../components/modal/Modal";
import { AddIndividualView } from "./AddIndividualView";
import AddOrganizationView from "./AddOrganizationView";
import { AddContactFormFrame } from "./components/AddContactFormFrame";
import { AddContactTypeSelection } from "./components/AddContactTypeSelection";
import { useAddContactModalController } from "./hooks/useAddContactModalController";
import { ADD_CONTACT_MODAL_WIDTH } from "./model/addContact.constants";
import { AddContactModalProps } from "./model/addContact.types";
import {
  individualPrefill,
  organizationPrefill,
} from "./utils/prefillFromSearch";

export const AddContactModal: React.FC<AddContactModalProps> = ({
  isOpen,
  closeModal,
  setIsLoading,
  setContactsForSort,
  isSearch = false,
  isIdLikeContactId = false,
  prefillText,
  initialType,
}) => {
  // QA batch 16 (NAV-009): Cancel / × / Esc in New Individual or New
  // Organization close the whole window (before they went back to "Choose
  // contact type", which then needed a second ×).
  const { step, closeAddContactModal, openContactForm } =
    useAddContactModalController({ isOpen, closeModal, initialType });

  if (!isOpen) {
    return null;
  }

  if (step === "individual") {
    return (
      <AddContactFormFrame onBack={closeAddContactModal}>
        <AddIndividualView
          setIsLoading={setIsLoading}
          closeModal={closeAddContactModal}
          closeAddCustomerPopupModal={closeAddContactModal}
          setContactsForSort={setContactsForSort}
          isSearch={isSearch}
          isIdLikeContactId={isIdLikeContactId}
          initialValues={
            prefillText ? individualPrefill(prefillText) : undefined
          }
        />
      </AddContactFormFrame>
    );
  }

  if (step === "organization") {
    return (
      <AddContactFormFrame onBack={closeAddContactModal}>
        <AddOrganizationView
          setIsLoading={setIsLoading}
          closeModal={closeAddContactModal}
          closeAddCustomerOrganizationPopupModal={closeAddContactModal}
          setContactsForSort={setContactsForSort}
          isSearch={isSearch}
          initialValues={
            prefillText ? organizationPrefill(prefillText) : undefined
          }
        />
      </AddContactFormFrame>
    );
  }

  return (
    <Modal onClose={closeAddContactModal} width={ADD_CONTACT_MODAL_WIDTH}>
      <AddContactTypeSelection
        onClose={closeAddContactModal}
        onSelectType={openContactForm}
      />
    </Modal>
  );
};
